import React from "react";
import "../style/AccountArea.scss";

const AccountArea = ({ children }) => {
  return <div className="accountArea">{children}</div>;
};

export default AccountArea;
